export default __webpack_public_path__ + "static/media/visasecure.528ebe16.png";